import { Client } from 'src/admin/users/types';
import { Family } from './hooks/useFamily';

// Legacy families use mainFamilyMember + secondaryFamilyMembers; role-model
// families keep every member in `members` with no secondary rows. `members` is
// the source of truth for membership, so it is always unioned in. This is
// additive for legacy star families (their members are already covered by the
// primary and secondary rows), and surfaces role-model members regardless of
// the role-model flag.
export function getFamilyMemberClientIds(family: Family): string[] {
  const ids = new Set<string>();
  if (family.mainFamilyMember?.clientId) ids.add(family.mainFamilyMember.clientId);
  family.secondaryFamilyMembers.forEach(m => ids.add(m.clientId));
  family.members.forEach(m => ids.add(m.clientId));
  return [...ids];
}

export function formatFamilyMembers(family: Family, clientMap: Record<string, Client>): string {
  const memberIds = getFamilyMemberClientIds(family);
  const primaryId = family.mainFamilyMember?.clientId ?? memberIds[0];
  const primary = primaryId ? clientMap[primaryId] : undefined;
  if (!primary) return `${memberIds.length} members`;

  const primaryFullName = `${primary.firstName} ${primary.lastName}`;
  const otherIds = memberIds.filter(id => id !== primaryId);

  if (otherIds.length === 0) return primaryFullName;

  const firstOther = clientMap[otherIds[0]] as Client | undefined;

  let shownText: string;
  let othersCount: number;

  if (firstOther && firstOther.lastName === primary.lastName) {
    shownText = `${primary.firstName} & ${firstOther.firstName} ${primary.lastName}`;
    othersCount = otherIds.length - 1;
  } else {
    shownText = primaryFullName;
    othersCount = otherIds.length;
  }

  if (othersCount === 0) return shownText;
  return `${shownText}, and ${othersCount} other${othersCount === 1 ? '' : 's'}`;
}
